export const LearningObjectivesCell = ({ objectives }: { objectives: string[] }) => {
  return objectives.map((objective) => (
    <div key={objective} className="flex items-center gap-x-2">
      <span className="h-2 w-2 rounded-full bg-secondary-foreground" />
      <span>{objective}</span>
    </div>
  ));
};
